import jquery from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

/**
 * 郵便番号自動入力イベント
 */
export default class EFOcats_event_postno extends EFOcats_event_core {
  /**
   * イベントための事前の仕込み
   */
  init() {
    // 処理なし
  }

  /**
   * イベント本体をセット
   */
  event() {
    this.$('.yubin-num input').on('change', event => {
      const element = event.currentTarget;
      const target = jquery(element);

      if (target.attr('type') === 'tel') {
        this.rep_yubin(target);
      }
      const yubin = target.val();

      // 郵便番号が空の時にアイコンフラグを外す
      if (yubin === '') {
        target.parents('.message-flag').removeClass('icon-flag');
      }

      this.adress(yubin)
        .promise()
        .then(data => {
          const address_data = data.results;

          if (address_data === null) {
            target
              .parents('section')
              .find('input,select')
              .each((index, elem) => {
                if (jquery(elem).parent('.check-flag').hasClass('yubin-num')) {
                  jquery(elem).addClass('yubin-null');
                }
              });

            target.parents('.message-flag').removeClass('icon-flag');
            target.parents('.message-flag').removeClass('ok-flag');
            target.parents('.message-flag').attr('data-error-text', this.langagerList('郵便1エラー'));
            target.parents('section').removeClass('go-flag');
          } else {
            if (target.hasClass('yubin-null')) {
              target.removeClass('yubin-null');
            }

            const address_prefectures = address_data[0].address1;
            const address_city = address_data[0].address2;
            const address_state = address_data[0].address3;

            target.parents('section').find('.adress1').find('select').val(address_prefectures);
            target
              .parents('section')
              .find('.adress2')
              .find('input')
              .val(address_city + address_state);

            // データが入ったらOKフラグをつける
            target.parents('section').find('.adress1').find('select').removeClass('error-modifer');
            target.parents('section').find('.adress1').addClass('ok-flag');
            target.parents('section').find('.adress1').addClass('icon-flag');
            target.parents('section').find('.adress1').attr('data-error-text', '');

            target.parents('section').find('.adress2').find('input').removeClass('error-modifer');
            target.parents('section').find('.adress2').addClass('ok-flag');
            target.parents('section').find('.adress2').addClass('icon-flag');
            target.parents('section').find('.adress2').attr('data-error-text', '');
          }
        });
    });
  }

  adress(yubin) {
    const deferr = new jquery.Deferred();

    jquery
      .ajax({
        url: `https://formcats.com/show/zipcode.php?zipcode=${yubin}`,
        type: 'GET',
        dataType: 'json',
      })
      .done(data => {
        deferr.resolve(data);
      })
      .fail(e => {});
    return deferr.promise(this);
  }
}
